import { Card, Chip } from '@offerzen/pinata'
import React, { useState } from 'react'
import { useAnalytics } from 'clientHelpers/context/analyticsContext'
import BigModal from 'components/BigModal'
import GetStartedModal from 'components/GetStartedModal'
import { differenceInWeeks } from 'date-fns'
import { cx } from '@emotion/css'
import PropTypes from 'prop-types'
import ProfileOverview from './elements/ProfileOverview'
import Roles from './elements/Roles'
import Skill from './elements/Skill'
import styles from './styles'

const CandidateCard = ({
  batchDate,
  candidateIndex,
  roleName,
  preferredCities,
  roles,
  profilePicture,
  skills,
  otherSkills,
  salary,
  filtersSelected,
}) => {
  const { trackClickCandidateCard } = useAnalytics()
  const [isModalOpen, setModalOpen] = useState(false)

  const handleOpenModal = () => {
    trackClickCandidateCard(candidateIndex, 'view candidate')
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const isNewCandidate = differenceInWeeks(new Date(), new Date(batchDate)) === 0

  return (
    <>
      <Card className={cx(styles.wrapper, styles.hoverEffects)} onClick={handleOpenModal}>
        <div className={styles.mobileChipWrapper}>
          {isNewCandidate && <Chip label="New this week" className={styles.mobileChip} size="small" theme="success" />}
        </div>
        <div className={styles.detailsContainer}>
          <ProfileOverview
            batchDate={batchDate}
            roleName={roleName}
            profilePicture={profilePicture}
            preferredCities={preferredCities}
            salary={salary}
            isNewCandidate={isNewCandidate}
          />

          <div className={styles.flexContainer}>
            <Roles className={styles.roles} roles={roles} filteredRoles={filtersSelected.roles} rolesCount={roles?.length} />

            <Skill
              className={styles.skills}
              skills={skills}
              otherSkills={otherSkills}
              filteredSkills={filtersSelected.skills}
              candidateIndex={candidateIndex}
            />
          </div>
        </div>
        <div className={styles.footerContainer}>
          <button className={`footerButton ${styles.footerButton}`} onClick={handleOpenModal} type="button">
            View candidate
          </button>
        </div>
      </Card>

      <BigModal open={isModalOpen} handleClose={handleCloseModal} handleOpen={handleOpenModal}>
        {({ close }) => <GetStartedModal handleClose={close} />}
      </BigModal>
    </>
  )
}

CandidateCard.propTypes = {
  roleName: PropTypes.string,
  preferredCities: PropTypes.arrayOf(PropTypes.string),
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      experience: PropTypes.shape({
        min: PropTypes.string,
        max: PropTypes.string,
      }),
    }),
  ),
  skills: PropTypes.arrayOf(PropTypes.string),
  otherSkills: PropTypes.number,
  salary: PropTypes.string,
  filteredValues: PropTypes.array,
  candidateIndex: PropTypes.number,
  batchDate: PropTypes.string,
  profilePicture: PropTypes.string,
  filtersSelected: PropTypes.shape({
    roles: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
    skills: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
}

export default CandidateCard
